export default class PermissionService {

    static ROLE_ADMIN = 1;
    static ROLE_STABLE_MANAGER = 2;
    static ROLE_RIDING_INSTRUCTOR = 3;
    static ROLE_GROOM = 4;
    static ROLE_CUSTOMER = 5;
    static ROLE_VETERINARIAN = 6;
    static ROLE_FARMER = 7;

    static ALL_ROLES = {
        1: 'Admin',
        2: 'Stable Manager',
        3: 'Riding Instructor',
        4: 'Groom',
        5: 'Customer',
        6: 'Veterinarian',
        7: 'Farrier'
    };


    static PERMISSION_TRAINIGN = 'training_permissions';
    static PERMISSION_HORSE_INFO = 'horse_info_permissions';
    static PERMISSION_WEIGHT = 'horse_weight_permissions';
    static PERMISSION_VACCINE = 'vaccines_permissions';
    static PERMISSION_THERAPY = 'therapy_permissions';
    static PERMISSION_DIAGNOSIS = 'diagnosis_permissions';
    static PERMISSION_OTHER_TREATMENT = 'other_periodic_treatment_permissions';
    static PERMISSION_SHOEING = 'shoeing_permissions';
    static PERMISSION_DIET = 'diet_permissions';

    static ALL_PERMISSIONS = [
        PermissionService.PERMISSION_TRAINIGN,
        PermissionService.PERMISSION_HORSE_INFO,
        PermissionService.PERMISSION_WEIGHT,
        PermissionService.PERMISSION_VACCINE,
        PermissionService.PERMISSION_THERAPY,
        PermissionService.PERMISSION_DIAGNOSIS,
        PermissionService.PERMISSION_OTHER_TREATMENT,
        PermissionService.PERMISSION_SHOEING,
        PermissionService.PERMISSION_DIET
    ];

    static PERMISSION_LABELS = {
        training_permissions: "Addestramento",
        diet_permissions: "Dieta",
        shoeing_permissions: "Ferratura",
        other_periodic_treatment_permissions: "Trattamenti periodici",
        diagnosis_permissions: "Diagnosi",
        therapy_permissions: "Terapia",
        vaccines_permissions: "Vaccini",
        horse_weight_permissions: "Peso cavallo",
        horse_info_permissions: "Info cavallo"
    }

    static hasPermission(horse, permission) {
        if(!horse || !permission) return false;
        if(horse.is_owner) return true;
        if(horse.is_admin) return true;
        if (horse.permissions) {
            if (Array.isArray(permission)) {
                return permission.some(perm => horse.permissions[perm] === true);
            }
            if (horse.permissions[permission] === true) return true;
        }
        return false;
    }

    static isInstructor(user) {
        return user && [
            PermissionService.ROLE_RIDING_INSTRUCTOR,
            PermissionService.ROLE_ADMIN,
            PermissionService.ROLE_STABLE_MANAGER
        ].includes(user.role_id);
    }

}
